import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";

export default function Protestos({
  cartorios,
  isConsultaNova,
}: {
  cartorios: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const hasCartorios = cartorios && cartorios.length > 0;
  const resumos = hasCartorios && cartorios[0].resumos ? cartorios[0].resumos : null;

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: hasCartorios ? '#FEF2F2' : '#F0FDF4',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className={hasCartorios ? 'pi pi-exclamation-triangle' : 'pi pi-check-circle'}
              style={{ color: hasCartorios ? '#DC2626' : '#16A34A', fontSize: '18px' }}
            />
          </div>
          <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
            {t('protestos')}
          </h3>
        </div>

        {!hasCartorios ? (
          <NadaConsta />
        ) : (
          <>
            {/* Resumo summary cards */}
            {resumos && (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                  gap: '12px',
                  marginBottom: '24px',
                }}
              >
                {resumos.map((item: any, idx: number) => (
                  <div
                    key={idx}
                    style={{
                      backgroundColor: '#1E3A8A',
                      borderRadius: '12px',
                      padding: '14px 16px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <span style={{ color: '#93C5FD', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase' }}>
                        {item.label}
                      </span>
                      <span style={{ color: '#FFFFFF', fontWeight: 800, fontSize: '1.1rem' }}>{item.value}</span>
                    </div>
                    <span
                      style={{
                        backgroundColor: 'rgba(255,255,255,0.15)',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i className={item.icon} style={{ color: '#FFFFFF', fontSize: '14px' }} />
                    </span>
                  </div>
                ))}
              </div>
            )}

            {/* Cartórios list */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {cartorios.map((cartorio: any, idx: number) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: '#F9FAFB',
                    border: '1px solid #E5E7EB',
                    borderRadius: '12px',
                    padding: '16px',
                  }}
                >
                  {/* Cartório header */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                    <i className="pi pi-building" style={{ color: '#DC2626', fontSize: '16px' }} />
                    <span style={{ fontWeight: 700, color: '#1F2937' }}>{cartorio.nome}</span>
                    <span
                      style={{
                        backgroundColor: '#FEE2E2',
                        color: '#9B1C1C',
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        padding: '2px 8px',
                        borderRadius: '4px',
                        marginLeft: 'auto',
                      }}
                    >
                      {cartorio.quantidade} protesto{cartorio.quantidade !== 1 ? 's' : ''}
                    </span>
                  </div>

                  {/* Cartório details */}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                      gap: '10px',
                      marginBottom: cartorio.protestos ? '12px' : '0',
                    }}
                  >
                    {[
                      { label: t('uf'), value: cartorio.uf },
                      { label: t('fone'), value: cartorio.telefone },
                      { label: t('endereco'), value: cartorio.endereco },
                    ].map(f => (
                      <div key={f.label} style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase' }}>
                          {f.label}
                        </span>
                        <span style={{ fontSize: 'small', color: '#374151', wordBreak: 'break-word' }}>
                          {f.value || 'Não informado'}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Protestos table */}
                  {cartorio.protestos && cartorio.protestos.length > 0 && (
                    <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #E5E7EB', marginTop: '8px' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 'small' }}>
                        <thead>
                          <tr style={{ backgroundColor: '#F3F4F6', borderBottom: '1px solid #E5E7EB' }}>
                            <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 700, color: '#6B7280', fontSize: '0.7rem', textTransform: 'uppercase' }}>
                              {t('data')}
                            </th>
                            <th style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 700, color: '#6B7280', fontSize: '0.7rem', textTransform: 'uppercase' }}>
                              {t('valor')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartorio.protestos.map((p: any, pIdx: number) => {
                            const isDateValid = (str: string) =>
                              /^\d{2}\/\d{2}\/\d{4}$/.test(str) || /^\d{4}-\d{2}-\d{2}/.test(str);
                            const dataValida = p.data && isDateValid(p.data.trim()) ? p.data.trim() : '';
                            return (
                              <tr key={pIdx} style={{ borderBottom: pIdx < cartorio.protestos.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                                <td style={{ padding: '8px 12px', color: '#374151' }}>{dataValida}</td>
                                <td style={{ padding: '8px 12px', color: '#DC2626', fontWeight: 700, textAlign: 'right' }}>{p.valor}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  // Legacy layout
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return (
      <div className={className}>
        {hasCartorios ? (
          <span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle">
            <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
              {t('protestos')}
            </span>
          </span>
        ) : (
          <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
            {t('protestos')}
          </span>
        )}
      </div>
    );
  };

  return (
    <Panel headerTemplate={headerTemplate}>
      {(!cartorios || cartorios.length === 0) && <NadaConsta />}
      {cartorios && cartorios.length > 0 && cartorios.map((cartorio: any, index: number) => (
        <>
          {index === 0 && (
            <div>
              <div className="flex-consulta flex-wrap gap-3">
                {cartorios[0].resumos.map((item: any, index: number) => (
                  <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                    <div className="flex-consulta justify-content-between gap-5">
                      <div className="flex-consulta flex-column gap-1">
                        <span style={{ color: 'white' }} className="text-sm">{item.label}</span>
                        <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                        <i className={item.icon} />
                      </span>
                    </div>
                  </Card>
                ))}
              </div>
              <br></br>
              <br></br>
            </div>
          )}
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div>
                <label className="label-dados">{t('cartorio')}</label>
                <Chip style={{ width: "100%" }} label={cartorio.nome} />
              </div>
            </div>
            <div className="col">
              <div>
                <label className="label-dados">{t('quantidade')}</label>
                <Chip style={{ width: "100%" }} label={cartorio.quantidade} />
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div>
                <label className="label-dados">{t('uf')}</label>
                <Chip style={{ width: "100%" }} label={cartorio.uf} />
              </div>
            </div>
            <div className="col">
              <div>
                <label className="label-dados">{t('fone')}</label>
                <Chip style={{ width: "100%" }} label={cartorio.telefone} />
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div>
                <label className="label-dados">{t('endereco')}</label>
                <Chip style={{ width: "100%" }} label={cartorio.endereco} />
              </div>
            </div>
          </div>
          {cartorio.protestos ? (
            <>
              <br></br>
              <DataTable size="small" value={cartorio.protestos} tableStyle={{ minWidth: '50rem' }}>
                <Column header={t('data')} body={(p: any) => {
                  const isDateValid = (str: string) =>
                    /^\d{2}\/\d{2}\/\d{4}$/.test(str) || /^\d{4}-\d{2}-\d{2}/.test(str);
                  return p.data && isDateValid(p.data.trim()) ? p.data.trim() : '';
                }}></Column>
                <Column field="valor" header={t('valor')}></Column>
              </DataTable>
              <br></br>
              <br></br>
              <br></br>
            </>
          ) : ''}
        </>
      ))}
    </Panel>
  );
}
